import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { IDcMetadataResponse, IMetadataElement } from './models/metadata.model';

@Injectable({
	providedIn: 'root',
})
export class MetadataRequester extends DcBaseRequester<IDcMetadataResponse> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('METADATA');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getMetadataList(
		useCache: boolean
	): Observable<ReadonlyArray<IDcMetadataResponse>> {
		const url = this.urlService.generateUrl(
			this.resource,
			{},
			{
				project: this.projectId,
			}
		);
		const cachePolicy = useCache
			? CachePolicyEntity.build({
					policy: CachePolicy.NetworkAndCache,
					maxAgeInSeconds: 60,
					isCacheable: true,
			  })
			: CachePolicyEntity.build({
					policy: CachePolicy.NetworkOnly,
					maxAgeInSeconds: 0,
					isCacheable: false,
			  });
		return this.get<Array<IDcMetadataResponse>>(url, cachePolicy);
	}

	public getElementIdFromMetadata(
		metadataId: number,
		metadataType: string
	): Observable<IMetadataElement> {
		const resourceUrl = this.generateResourceUrl('ELEMENT_ID_FROM_METADATA');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				metadataId,
				hdhType: metadataType,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.get<IMetadataElement>(url);
	}
}
